import * as qs from 'qs';

import { httpCall } from '../../common/util';
import SpockViewActionApiMapping from './actionURLMapping';
import { fetchUsersList } from '../AdminPanel/features/users/usersAPI';


// export const fetchUserInfo = (userId) => (
//   httpCall({
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     data: {},
//     url: `/usrinf?uid=${userId}`
//   })
// );

export const fetchOrgInfo = (orgId) => (
  httpCall({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {},
    url: `/1.0/organization/info?id=${orgId}`
  })
)

export const getActivityOwnerList = (activityId) => (
  httpCall({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {},
    url: `/gaol?activityId=${activityId}`
  })
);

export const changeActivityCurrentOwner = (data) => (
  httpCall({
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data,
    url: `/cacto`
  })
);

export const fetchActivityReassignUsers = (ActionType, payload) => httpCall({
  method: SpockViewActionApiMapping[ActionType].method,
  header: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  url: `${SpockViewActionApiMapping[ActionType].url}?${qs.stringify(payload)}`
});


export const fetchNoteSummary = (noteId) => (
  httpCall({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {},
    url: `/getnotesummary?id=${noteId}`
  })
);

export const getActivityNotification = (payload) => (
  httpCall({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    url: `/gauid?${qs.stringify(payload)}`
  })
);


export const getWorkkardOwnerList = (payload) => (
  httpCall({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {},
    url: `/gcsl?workkardId=${(payload.allOwner) ? (payload.w_id + '&allOwner=' + payload.allOwner) : (payload.w_id)}`
  })
);

export const getWorkkardOwnerListV2 = () => (  
  fetchUsersList({ page: 1, limit: 2000, deleted: false, type:'activity' })
);


export const changeWorkkardCurrentOwner = (data) => (
  httpCall({
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data,
    url: `/clmcs`
  })
);

export const changeWorkkardSponsor = (workkardId, data) => (
  httpCall({
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    data,
    url: `/1.0/workkard/change_sponsor/${workkardId}`
  })
);


export const reassignActivityFromView = (actionType, payload) => httpCall({
  method: SpockViewActionApiMapping[actionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: payload,
  url: SpockViewActionApiMapping[actionType].url
});

export const getValidChangeActivityAssigneeInfo = (actionType, payload) => httpCall({
  method: SpockViewActionApiMapping[actionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: payload,
  url: SpockViewActionApiMapping[actionType].url
});

export const bulkReassignActivitiesFromViews = (actionType, payload) => httpCall({
  method: SpockViewActionApiMapping[actionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data:payload,
  url: SpockViewActionApiMapping[actionType].url
});

export const validateWorkkardIdsForChangeOwner = (data) => (
  httpCall({
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data,
    url: `/Sponsor/GetValidIdsForChangeWorkkardOwner`
  })
);

export const validateDiaryIdsForChangeOwner = (data) => (
  httpCall({
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: data,
    url: `/DiaryBulkAction/GetImpactedIdsForChangeOwner`
  })
);

export const bulkValidateChangeActivityOwner = (ActionType, payload) => httpCall({
  method: SpockViewActionApiMapping[ActionType].method,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: payload,
  url: SpockViewActionApiMapping[ActionType].url
});
